import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EChartsOption, LineSeriesOption, matrix } from 'echarts';
import moment from 'moment';
import { RiskProfileGraph } from 'src/app/common/modules/charts/components/risk-line-graph/risk-line-graph.component';
import { ScreenType } from 'src/app/enums/ScreenType';
import { environment } from 'src/app/environments/environments';
import { animalAnalytics, assetAnalytics, BookingAnalytics, eventAnalytics, IncidentAnalytics, IRiskStatusGraph, VisitorAnalytics } from 'src/app/models/incident';
import {
  IRiskGraph,
  IRiskHeatMap,
  IRiskQuestions,
  IRiskSingleGraph,
} from 'src/app/models/riskProfile';
import { VisitorTickets } from 'src/app/models/tickets';
import { EncryptionService } from 'src/app/services/Encryption/encryption.service';
import { AumyeResponsiveScreenService } from 'src/app/services/screenResize/aumye-responsive-screen.service';
import { IAnalyticsState } from 'src/app/state-management/states/aumye-analytics.state';

interface ResolutionData {
  [date: string]: number;
}
export interface IncidentStatusDuration {
  date: string;       // e.g. "21-04-2025"
  statusName: string; // e.g. "Open"
  count: number;      // e.g. 3
}

type VisitorInput = { [date: string]: { [status: string]: number } };

type VisitorOutput = {
  expected: { [date: string]: number };
  attended: { [date: string]: number };
  ratio: { [date: string]: number };
};
@Component({
  selector: 'app-risk-view-analyticss',
  templateUrl: './risk-view-analyticss.component.html',
  styleUrl: './risk-view-analyticss.component.scss',
})
export class RiskViewAnalyticssComponent implements OnInit {
  ResolutionRateChart: EChartsOption;
  transitionMatrixChart: EChartsOption;
  getRepeatingVisitors: EChartsOption;
  visitorStatisticsData: EChartsOption;
  breakdownGraphData: any;
  incidentGraphCounts: any;
  getCheckInToCheckOutRatio: EChartsOption;
  getBookingByDates: EChartsOption;
  getBookingByAssets: EChartsOption;
  // assetAnalytics: { getBookingByDates: { [date: string]: number; }; getBookingByAssets: { [date: string]: { [assetId: string]: number; }; }; };
  bookingAnalytics: BookingAnalytics;
  eventAnalytics: eventAnalytics;
  animalAnalytics: animalAnalytics;
  assetAnalytics: assetAnalytics;
  totalEventChart: EChartsOption;
  getVisitorPerEventChart: EChartsOption;
  getVisitorAttendedRatioChart: EChartsOption;
  getAnimalFoodConsumptionChart: EChartsOption;
  getCostMaintenanceChart: EChartsOption;
  getPowerConsumptionChart: EChartsOption;
  getPropertyPowerConsumptionChart: EChartsOption;
  getPropertyTemperature: EChartsOption;
  @Input() set analyticsData(val: IAnalyticsState) {
    if (val) {
      this.monthlyVisitorCategory = val.monthlyVisitorCategory;
      this.visitorTickets = val.visitorTickets;
      this.riskQuestions = val.riskQuestions;
      this.rishGraphData = val.riskAnalyticsGraph;
      this.riskAnalyticsPreviousMonthGraph =
        val.riskAnalyticsPreviousMonthGraph;
      this.riskGraphData = {
        riskQuestions: this.riskQuestions,
        riskCurrent: this.rishGraphData,
        riskPrevious: this.riskAnalyticsPreviousMonthGraph,
      };
      this.riskSingleData = val.riskSingleAnalyticsGraph;
      this.averageCloseTime = val.averageCloseTime;
      this.criticalIncidentsCounts = val.criticalIncidentsCounts;
      this.criticalIncidentsData = val.criticalIncidentsData;
      this.criticalIncidentsCountNumber = val.criticalIncidentsCountNumber;
      this.currentMonthRiskScore = val.currentMonthRiskScore;
      this.previousMonthRiskScore = val.previousMonthRiskScore;
      this.criticalRiskHour = this.riskHourSpan[val.criticalRiskHour];
      this.riskHeatMapData = val.riskHeatMapData;
      this.riskAnalyticsStatusGraph = val.riskAnalyticsStatusGraph;
      this.currentMonthClaimTotal = val.currentMonthClaimTotal;
      this.previousMonthClaimTotal = val.previousMonthClaimTotal;
      this.currentMonthClaimAmount = val.currentMonthClaimAmount;
      this.previousMonthClaimAmount = val.previousMonthClaimAmount;
      this.monthlyVisitorBarGraph = val.monthlyVisitorBarGraph;
      this.monthlyVisitorInOutGraph = val.monthlyVisitorInOutGraph;
      this.uniqueVisitors = val.uniqueVisitors;
      this.currentDayVisitors = val.currentDayVisitors;
      this.hotCheckInSlot = this.riskHourSpan[val.hotCheckInSlot];
      this.calculatePercentageChange();

      this.riskScors = {
        averageCloseTime: val.averageCloseTime,
        criticalIncidentsCountNumber: val.criticalIncidentsCountNumber,
        criticalRiskHour: this.riskHourSpan[val.criticalRiskHour],
        currentDayVisitors: val.currentDayVisitors,
        currentMonthClaimAmount: val.currentMonthClaimAmount,
        currentMonthClaimTotal: val.currentMonthClaimTotal,
        currentMonthRiskScore: val.currentMonthRiskScore,
        hotCheckInSlot: this.riskHourSpan[val.hotCheckInSlot],
        uniqueVisitors: val.uniqueVisitors
      }
      this.incidentAnalytics = val.incidentAnalytics;
      this.visitorAnalytics = val.visitorAnalytics;
      this.assetAnalytics = val.assetAnalytics;
      this.bookingAnalytics = val.bookingAnalytics;
      this.eventAnalytics = val.eventAnalytics;
      this.animalAnalytics = val.animalAnalytics;

      this.breakdownGraphData = this.incidentAnalytics.breakdownGraphData;
      this.incidentGraphCounts = this.incidentAnalytics.incidentGraphCounts;
      this.updateRiskScore(this.riskScors);
      this.incidentStatusCountsChart = this.generateIncidentStatusChart(this.incidentAnalytics.incidentStatusCounts);
      this.incidentsCategoriesCountChart = this.generateIncidentStatusChart(this.incidentAnalytics.incidentCountByCategory);
      // this.AverageTimeChart = this.generateAverageTimeChart(this.incidentAnalytics);
      this.AverageTimeChart = this.generateStatusTrendChart(this.incidentAnalytics.averageTimePerStatus);
      this.ResolutionRateChart = this.generateResolutionRateChart(this.incidentAnalytics.resolutionRatePerDay);
      // this.transitionMatrixChart = this.generateTransitionMatrixChart(this.incidentAnalytics.transitionMatrix);
      // this.transitionMatrixChart = this.buildBumpChart(this.incidentAnalytics.transitionMatrixPerDate);
      this.transitionMatrixChart = this.generateTransitionStatusChart(this.incidentAnalytics.transitionMatrixPerDate);

      // this.getRepeatingVisitors = this.generateVisitorBumpChart(this.visitorAnalytics.getRepeatingVisitors);
      this.visitorStatisticsData = this.generateIncidentStatusChart(this.visitorAnalytics.visitorTypeTotals);
      this.getRepeatingVisitors = this.generateVisitorLineChart({
        'Total Visitors': this.visitorAnalytics.getTotalVisitors,
        'Unique Visitors': this.visitorAnalytics.getUniqueVisitors,
        'Repeating Visitors': this.visitorAnalytics.getRepeatingVisitors,
        // getCheckInToCheckOutRatio: {}
      });
      this.getCheckInToCheckOutRatio = this.generateVisitorLineChart({ "CheckIn To CheckOut Ratio": this.visitorAnalytics.getCheckInToCheckOutRatio });
      this.getBookingByDates = this.generateVisitorLineChart({ "Booking": this.bookingAnalytics.getBookingByDates });
      this.getBookingByAssets = this.generateIncidentStatusChart(this.bookingAnalytics.getBookingByAssets);
      this.totalEventChart = this.generateIncidentStatusChart(this.eventAnalytics.getTotalEvent)
      this.getVisitorPerEventChart = this.generateIncidentStatusChart(this.eventAnalytics.getVisitorPerEvent)
      this.getVisitorAttendedRatioChart = this.generateVisitorLineChart(this.flipVisitorSchema(this.eventAnalytics.getVisitorAttentedToTotalRatio))
      this.getAnimalFoodConsumptionChart = this.generateIncidentStatusChart(this.animalAnalytics.getFoodCosumption);
      this.getCostMaintenanceChart = this.generateIncidentStatusChart(this.animalAnalytics.getCostOfMaintenance);
      this.getPowerConsumptionChart = this.generateIncidentStatusChart(this.assetAnalytics.getPowerConsumption);
      this.getPropertyPowerConsumptionChart = this.generateIncidentStatusChart(this.assetAnalytics.getPropertyPowerConsumption);
      this.getPropertyTemperature = this.generateIncidentStatusChart(this.assetAnalytics.getPropertyTemperature);
      this.transitionKeys = Object.keys(this.incidentAnalytics.transitionMatrix);
    }
    // console.log(this.assetAnalytics);
  }

  riskScorsIndicators = [
    { label: 'MONTHLY RISK SCORE', value: '0', subtext: 'Risk score of current month' },
    { label: 'AVERAGE CLOSING TIME', value: '0m', subtext: 'Average time for an incident to close' },
    { label: 'CRITICAL INCIDENT COUNT', value: '0', subtext: 'Total critical incident reported' },
    { label: 'CRITICAL RISK HOUR', value: '12AM', subtext: 'Most active Time Span' },
    { label: 'HOT HOUR', value: '12AM', subtext: 'Most check-in timeslot' },
    { label: 'UNIQUE VISITOR', value: '0', subtext: 'Visitors in the current month' },
    { label: 'TOTAL UNCHECKED OUT', value: '0', subtext: 'Count of visitors pending checkout' },
    { label: 'TOTAL CLAIMS AMOUNT', value: '0', subtext: 'Total claim amount for this month' },
    { label: 'TOTAL CLAIMS', value: '0', subtext: 'Total claim requests for the month' },
  ];

  transitionKeys: any;
  incidentAnalytics: IncidentAnalytics;
  visitorAnalytics: VisitorAnalytics;
  riskGraphData: RiskProfileGraph;
  visitorTickets: VisitorTickets[] = [];
  riskQuestions: IRiskQuestions[] = [];
  rishGraphData: IRiskGraph[] = [];
  riskAnalyticsPreviousMonthGraph: IRiskGraph[] = [];
  riskSingleData: IRiskSingleGraph[] = [];
  riskAnalyticsStatusGraph: IRiskStatusGraph[] = [];
  riskHeatMapData: IRiskHeatMap[] = [];
  averageCloseTime: number = 0;
  monthlyVisitorCategory: any = null;
  criticalIncidentsData: any = null;
  criticalIncidentsCounts: any[] = [];
  criticalIncidentsCountNumber: any;
  currentMonthRiskScore: number;
  previousMonthRiskScore: number;
  screenSize: ScreenType;
  criticalRiskHour: string = null;
  hotCheckInSlot: string = null;
  currentMonthClaimTotal: number;
  previousMonthClaimTotal: number;
  currentMonthClaimAmount: number;
  previousMonthClaimAmount: number;
  monthlyVisitorBarGraph: any[] = [];
  monthlyVisitorInOutGraph: any[] = [];
  uniqueVisitors: number = 0;
  currentDayVisitors: number = 0;
  riskHourSpan: string[] = [
    '00:00-02:00',
    '02:00-04:00',
    '04:00-08:00',
    '08:00-10:00',
    '10:00-12:00',
    '12:00-14:00',
    '14:00-16:00',
    '16:00-18:00',
    '18:00-20:00',
    '20:00-22:00',
    '22:00-24:00',
  ];
  incidentStatusCountsChart: EChartsOption;
  incidentsCategoriesCountChart: EChartsOption;
  AverageTimeChart: EChartsOption;
  riskScors = {
    currentMonthRiskScore: 0,
    averageCloseTime: 0,
    criticalIncidentsCountNumber: 0,
    criticalRiskHour: this.riskHourSpan[0],
    currentMonthClaimTotal: 0,
    currentMonthClaimAmount: 0,
    uniqueVisitors: 0,
    hotCheckInSlot: this.riskHourSpan[0],
    currentDayVisitors: 0
  }

  percentageChange: number;
  percentageChangeClaim: number;
  percentageChangeClaimNumber: number;
  isDecreasing: boolean;
  isHide = false;
  orgid: string = null;
  profilePic = localStorage.getItem('ProfilePic')
    ? localStorage.getItem('ProfilePic')
    : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAMAAAD04JH5AAAAMFBMVEXk5ueutLepr7Ln6erg4uPJzc/T1ti7wMO2u77DyMqzuLvq7O3P0tTW2dvc3+DZ3N7ueM45AAAC2UlEQVR4nO2a2ZLjIAxFAYHZvPz/3za2O8v0JCA5kl3dxXly5eXeCAmDZKU6nU6n0+l0Op1O5/cCAErZglofzle3UwxJryTvFnWuB4DJa2P0DWNSnM+zAHnUD/G7Cb/kc/Tz9EJ+t3DKQkB8Lb8xiDsAFSr62jhhB2BTRX51EEUdgK3Lb4kg6qDx/6VjAL6tXxyMUg7A1fLvyYHQngQLTr/szUIGAlJfqBhhxAagIKCvAC+vtUQIBkIAtOE3kNEZsBkQKEVKALQO3AZIKbiGwHIbQG2CTwbYX8w0fa253wgzbQVKEvDqA6kIN5gNIN9DT8y8BiJVXy8XGzATrwFiFa51+McMXL4Elyfh1WVIOw1s8OorS96K/9rL6PLXMfVAorkPJApoBvivqLQ1MBP/oRR9MdsQuBcA4mp+D4DI3WwihEDkdorPAv4j8U67P/ONVJcGvRdYqRZJ9hgHEiV4A9OjkGsRbVTblJu+dKuy4UBcvxRjtVUr3ywup7P38uGUoQHM74Lgzprd5OVFJpgoVv6vLMzu35FNGE+eGq1TqzH6kFIKPg7XDM4y3Mhnz8zK/7XLMLq44cZhmfdfTxDPah5jKKu+ck+B9TlFNynRYKzDSheek+9nIWiT4mBlIlGCPnj9ZmD3bMLo4Gb2kthHpS3xhwk/sFoA5RLxXmLKvsQ1SAVbG1VWPISFIwpF/oj6bsEzWHg1pyZYiJ/lQl6oa/+fAz1+kAr52OL/sJCOBgHm5gEQybFjEgw86nrLBDqZ3herOPDkRKh+pnDAAXV8wKyvqQMMfn2aA9b1fzhA5wFQWhF48N9WkLuiWAfY/YA0pCWBamAfaIyjQTWQ0Y2YA2B6B5k8nCHRDgB5REqi3T6gT6eINNdANADtUpQsgR3fCIDcHnCjPkiQ2gQf1NfgwJSeTPVscmA+SSbVVgD/tdYHVJOAMJQ4TG2ma78bD6LwjtU7nU6n8/v5AuY6HZyRatEhAAAAAElFTkSuQmCC';
  disabledOrgIds: string[] = [];
  isDisableFeature: boolean = false;
  constructor(
    private dialog: MatDialog,
    private screen: AumyeResponsiveScreenService,
    private encryptionService: EncryptionService
  ) {
    this.screen.getScreenType().subscribe((screenData) => {
      this.screenSize = screenData;
    });
    if (this.orgid == '766773b7-51e9-4951-a2de-6245e6233758') {
      this.isHide = true;
    }
  }
  ngOnInit(): void {
    const loggedUser = this.encryptionService.getCurrentUser();
    this.disabledOrgIds = environment.printerAllowed;
    this.isDisableFeature = this.disabledOrgIds
      .map((id) => id.toLowerCase())
      .includes(loggedUser.organizationID?.toLowerCase());
  }

  getClass(label: string): string {
    switch (label) {
      case 'MONTHLY RISK SCORE': return 'success';
      case 'AVERAGE CLOSING TIME': return 'danger';
      case 'CRITICAL INCIDENT COUNT': return 'warning';
      case 'CRITICAL RISK HOUR': return 'info';
      case 'HOT HOUR': return 'purple';
      case 'UNIQUE VISITOR': return 'success';
      case 'TOTAL UNCHECKED OUT': return 'danger';
      case 'TOTAL CLAIMS AMOUNT': return 'warning';
      // case '': return 'info';
      default: return 'info';
    }
  }

  updateRiskScore(val: any) {
    let incidentCountNumber = this.criticalIncidentsCountNumber?.emergencySos +
      this.criticalIncidentsCountNumber?.fire +
      this.criticalIncidentsCountNumber?.intrusions +
      this.criticalIncidentsCountNumber?.manual
    this.riskScorsIndicators = [
      { label: 'MONTHLY RISK SCORE', value: val.currentMonthRiskScore, subtext: 'Risk score of current month' },
      { label: 'AVERAGE CLOSING TIME', value: val.averageCloseTime, subtext: 'Average time for an incident to close' },
      { label: 'CRITICAL INCIDENT COUNT', value: incidentCountNumber, subtext: 'Total critical incident reported' },
      { label: 'CRITICAL RISK HOUR', value: val.criticalRiskHour, subtext: 'Most active Time Span' },
      { label: 'HOT HOUR', value: val.hotCheckInSlot, subtext: 'Most check-in timeslot' },
      { label: 'UNIQUE VISITOR', value: val.uniqueVisitors, subtext: 'Visitors in the current month' },
      { label: 'TOTAL UNCHECKED OUT', value: val.currentDayVisitors, subtext: 'Count of visitors pending checkout' },
      { label: 'TOTAL CLAIMS', value: val.currentMonthClaimTotal, subtext: 'Total claim amount for this month' },
      { label: 'TOTAL CLAIMS AMOUNT', value: val.currentMonthClaimAmount, subtext: 'Total claim requests for the month' }
    ];
  }

  getFormatedDateTime(val: string) {
    let formatedDate = moment(val, 'YYYY-MM-DDTHH:mm:ss.SSS').fromNow();
    return formatedDate;
  }
  calculatePercentageChange() {
    this.percentageChange =
      ((this.currentMonthRiskScore - this.previousMonthRiskScore) /
        this.previousMonthRiskScore) *
      100;
    this.percentageChangeClaim =
      ((this.currentMonthClaimTotal - this.previousMonthClaimTotal) /
        this.previousMonthClaimTotal) *
      100;
    this.percentageChangeClaimNumber =
      ((this.currentMonthClaimAmount - this.previousMonthClaimAmount) /
        this.previousMonthClaimAmount) *
      100;
    this.isDecreasing = this.percentageChange < 0;
  }
  ScreenType = ScreenType;

  // generateIncidentStatusChart(data: { [key: string]: number }): EChartsOption {
  //   const categories = Object.keys(data);
  //   const values = Object.values(data);

  //   return {
  //     title: {
  //       text: 'Incident Status Counts',
  //       left: 'center',
  //       top: 10,
  //     },
  //     tooltip: {
  //       trigger: 'axis',
  //       axisPointer: { type: 'shadow' },
  //       formatter: (params: any) => {
  //         const total = params.reduce((sum: number, item: any) => sum + item.value, 0);
  //         return params
  //           .map(
  //             (item: any) =>
  //               `${item.name}: ${item.value} (${((item.value / total) * 100).toFixed(1)}%)`
  //           )
  //           .join('<br>');
  //       },
  //     },
  //     xAxis: {
  //       type: 'category',
  //       data: categories,
  //     },
  //     yAxis: {
  //       type: 'value',
  //       axisLabel: {
  //         formatter: '{value}',
  //       },
  //     },
  //     series: [
  //       {
  //         name: 'Incident Count',
  //         type: 'bar',
  //         data: values,
  //         itemStyle: {
  //           color: '#5470C6',
  //         },
  //         emphasis: {
  //           focus: 'series',
  //         },
  //       },
  //     ],
  //     toolbox: {
  //       feature: {
  //         saveAsImage: {},
  //       },
  //     },
  //   };
  // }

  // generateIncidentStatusChart(data: { [date: string]: { [status: string]: number } }): EChartsOption {
  //   const dates = Object.keys(data);
  //   const allStatusesSet = new Set<string>();

  //   // First pass to collect all unique statuses
  //   for (const date in data) {
  //     Object.keys(data[date]).forEach((status) => allStatusesSet.add(status));
  //   }

  //   const allStatuses = Array.from(allStatusesSet);

  //   // Initialize series data
  //   const series = allStatuses.map((status) => {
  //     return {
  //       name: status,
  //       type: 'bar',
  //       stack: 'total',
  //       emphasis: {
  //         focus: 'series',
  //       },
  //       data: dates.map((date) => data[date][status] || 0),
  //     };
  //   });

  //   return {
  //     title: {
  //       text: 'Incident Status Counts Over Time',
  //       left: 'center',
  //       top: 10,
  //     },
  //     tooltip: {
  //       trigger: 'axis',
  //       axisPointer: {
  //         type: 'shadow',
  //       },
  //       formatter: (params: any) => {
  //         const total = params.reduce((sum: number, item: any) => sum + item.value, 0);
  //         return params
  //           .map(
  //             (item: any) =>
  //               `${item.seriesName}: ${item.value} (${((item.value / total) * 100).toFixed(1)}%)`
  //           )
  //           .join('<br>');
  //       },
  //     },
  //     legend: {
  //       top: 40,
  //     },
  //     toolbox: {
  //       feature: {
  //         saveAsImage: {},
  //       },
  //     },
  //     xAxis: {
  //       type: 'category',
  //       data: dates,
  //       axisLabel: {
  //         rotate: 45,
  //       },
  //     },
  //     yAxis: {
  //       type: 'value',
  //     },
  //     series: series as echarts.EChartsOption['series'],
  //   };
  // }

  generateIncidentStatusChart(data: { [date: string]: { [status: string]: number } }, titleText: string = ''): EChartsOption {
    const dates = Object.keys(data);
    const allStatusesSet = new Set<string>();

    // Step 1: Collect all unique statuses
    for (const date in data) {
      Object.keys(data[date]).forEach((status) => allStatusesSet.add(status));
    }

    const allStatuses = Array.from(allStatusesSet);

    // Step 2: Compute total per date
    const totalPerDate = dates.map((date) => {
      const statusCounts = data[date];
      return Object.values(statusCounts).reduce((sum, count) => sum + count, 0);
    });

    // Step 3: Stacked bars by status
    const stackedBarSeries = allStatuses.map((status) => ({
      name: status,
      type: 'bar',
      stack: 'status',
      barWidth: 10,
      emphasis: {
        focus: 'series',
      },
      data: dates.map((date) => data[date][status] || 0),
    }));

    // Step 4: Separate bar for total count (non-stacked)
    const totalBarSeries = {
      name: 'Total',
      type: 'bar',
      // stack: undefined,
      barGap: '10%',
      itemStyle: {
        color: '#00BFA5',
      },
      data: totalPerDate,
      label: {
        show: true,
        position: 'top',
        formatter: '{c}',
      },
    };

    // Step 5: Line trend over total bars
    const totalTrendLineSeries = {
      name: 'Trend',
      type: 'line',
      data: totalPerDate,
      symbol: 'circle',
      symbolSize: 6,
      lineStyle: {
        color: 'red',
        width: 2,
      },
      label: {
        show: false,
      },
      emphasis: {
        focus: 'series',
      },
      z: 10,
    };

    return {
      // title: {
      //   text: titleText,
      //   left: 'center',
      //   top: 0,
      // },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
        formatter: (params: any) => {
          const total = params.reduce((sum: number, item: any) => sum + (item.value || 0), 0);
          return params
            .map(
              (item: any) =>
                `${item.seriesName}: ${item.value} (${((item.value / total) * 100).toFixed(1)}%)`
            )
            .join('<br>');
        },
      },
      legend: {
        top: 10,
      },
      toolbox: {
        feature: {
          saveAsImage: {},
        },
      },
      xAxis: {
        type: 'category',
        data: dates,
        axisLabel: {
          rotate: 45,
        },
      },
      yAxis: {
        type: 'value',
      },
      series: [...stackedBarSeries, totalBarSeries, totalTrendLineSeries] as echarts.EChartsOption['series'],
    };
  }


  // generateAverageTimeChart(data: IncidentAnalytics): EChartsOption {
  //   const categories = data.averageTimePerStatus.map(item => item.statusName);
  //   const durations = data.averageTimePerStatus.map(item => item.averageDurationMinutes);

  //   return {
  //     title: { text: 'Average Time per Status (minutes)', left: 'center', top: 10 },
  //     tooltip: {
  //       trigger: 'axis',
  //       axisPointer: { type: 'shadow' },
  //       formatter: (params: any) => {
  //         return params.map((item: any) => `${item.name}: ${item.value.toFixed(2)} min`).join('<br>');
  //       },
  //     },
  //     xAxis: {
  //       type: 'category',
  //       data: categories,
  //       axisLabel: {
  //         rotate: 45  // Rotate labels if they are too long (optional)
  //       }
  //     },
  //     yAxis: {
  //       type: 'value',
  //       axisLabel: { formatter: '{value} min' },
  //     },
  //     series: [
  //       {
  //         name: 'Average Duration',
  //         type: 'bar',
  //         data: durations,
  //         itemStyle: { color: '#91cc75' },
  //         emphasis: { focus: 'series' },
  //       },
  //     ],
  //     toolbox: { feature: { saveAsImage: {} } },
  //   };
  // }

  // generateStatusTrendChart(data: IncidentStatusDuration[]): EChartsOption {
  //   // Step 1: Transform into { [date]: { [status]: count } }
  //   const grouped: { [date: string]: { [status: string]: number } } = {};
  //   data.forEach(item => {
  //     if (!grouped[item.date]) {
  //       grouped[item.date] = {};
  //     }
  //     grouped[item.date][item.statusName] = item.count;
  //   });

  //   // Step 2: Sort dates
  //   const dates = Object.keys(grouped).sort((a, b) => {
  //     const [da, ma, ya] = a.split('-').map(Number);
  //     const [db, mb, yb] = b.split('-').map(Number);
  //     return new Date(ya, ma - 1, da).getTime() - new Date(yb, mb - 1, db).getTime();
  //   });

  //   // Step 3: Collect all unique statuses
  //   const allStatusesSet = new Set<string>();
  //   dates.forEach(date => {
  //     Object.keys(grouped[date]).forEach(status => allStatusesSet.add(status));
  //   });
  //   const allStatuses = Array.from(allStatusesSet);

  //   // Step 4: Build series for each status
  //   const series: any = allStatuses.map(status => ({
  //     name: status,
  //     type: 'bar', // change to 'line' if you want trend lines
  //     stack: 'total', // remove if you don’t want stacking
  //     emphasis: { focus: 'series' },
  //     data: dates.map(date => grouped[date][status] || 0)
  //   }));

  //   // Step 5: Return chart option
  //   return {
  //     title: { text: 'Incidents by Status per Day', left: 'center', top: 10 },
  //     tooltip: {
  //       trigger: 'axis',
  //       axisPointer: { type: 'shadow' }
  //     },
  //     legend: {
  //       top: 30,
  //       data: allStatuses
  //     },
  //     xAxis: {
  //       type: 'category',
  //       data: dates,
  //       axisLabel: { rotate: 45 }
  //     },
  //     yAxis: {
  //       type: 'value',
  //       name: 'Count'
  //     },
  //     series,
  //     toolbox: { feature: { saveAsImage: {} } }
  //   };
  // }

  generateStatusTrendChart(data: { [date: string]: { [status: string]: number } }): EChartsOption {
    // Step 1: aggregate total time per status
    const totals: { [status: string]: number } = {};

    Object.values(data).forEach(dayStatuses => {
      Object.entries(dayStatuses).forEach(([status, time]) => {
        totals[status] = (totals[status] || 0) + time;
      });
    });

    // Step 2: prepare chart categories and values
    const statuses = Object.keys(totals);
    const values = statuses.map(status => totals[status]);

    // Step 3: return chart option
    return {
      title: { text: 'Total Time per Status', left: 'center', top: 10 },
      tooltip: {
        trigger: 'axis',
        axisPointer: { type: 'shadow' },
        formatter: (params: any) =>
          params.map((item: any) => `${item.name}: ${item.value.toFixed(2)} hrs`).join('<br>')
      },
      xAxis: {
        type: 'category',
        data: statuses,
        axisLabel: { rotate: 45 }
      },
      yAxis: {
        type: 'value',
        name: 'Total Time',
        axisLabel: { formatter: '{value}' }
      },
      series: [
        {
          name: 'Total Time',
          type: 'bar',
          data: values,
          itemStyle: { color: '#5470c6' },
          emphasis: { focus: 'series' }
        }
      ],
      toolbox: { feature: { saveAsImage: {} } }
    };
  }




  generateResolutionRateChart(data: ResolutionData): EChartsOption {
    // Extract the dates (X-axis categories) and resolution rates (Y-axis values)
    const categories = Object.keys(data);
    const rates = Object.values(data);

    return {
      title: {
        text: '',
        left: 'center',
        top: 10
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        },
        formatter: (params: any) => {
          return params.map((item: any) => `${item.name}: ${item.value} resolutions`).join('<br>');
        }
      },
      xAxis: {
        type: 'category',
        data: categories,
        axisLabel: {
          rotate: 45  // Rotate labels if they are too long (optional)
        }
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: '{value} resolutions'
        }
      },
      series: [
        {
          name: 'Resolution Rate',
          type: 'bar',
          data: rates,
          itemStyle: { color: '#91cc75' },
          emphasis: {
            focus: 'series'
          }
        }
      ],
      toolbox: {
        feature: {
          saveAsImage: {}
        }
      }
    };
  }

  selectedRange: '1d' | '1w' | '1m' | '1y' = '1w';
  onRangeChange(range: '1d' | '1w' | '1m' | '1y', Analytic: string) {
    this.selectedRange = range;
    switch (Analytic) {
      case "IncidentStatusCounts":
        if (range === '1d') {
          this.incidentStatusCountsChart = this.generateIncidentStatusChart(this.incidentAnalytics.incidentStatusCounts, 'Incident Status Counts Over Time');
        } else {
          const data = this.aggregate(this.incidentAnalytics.incidentStatusCounts, range);
          this.incidentStatusCountsChart = this.generateIncidentStatusChart(data, 'Incident Status Counts Over Time');
          console.log(data);
        }
        break;

      case "IncidentsByCategories":
        if (range === '1d') {
          this.incidentsCategoriesCountChart = this.generateIncidentStatusChart(this.incidentAnalytics.incidentCountByCategory, 'Incident By Categories');
        } else {
          const data = this.aggregate(this.incidentAnalytics.incidentCountByCategory, range);
          this.incidentsCategoriesCountChart = this.generateIncidentStatusChart(data, 'Incident By Categories');
          console.log(data);
        }
        break;

      case "Visitors":
        if (range === '1d') {
          // this.incidentsCategoriesCountChart = this.generateIncidentStatusChart(this.incidentAnalytics.incidentCountByCategory, 'Incident By Categories');
          this.getRepeatingVisitors = this.generateVisitorLineChart({
            'Total Visitors': this.visitorAnalytics.getTotalVisitors,
            'Unique Visitors': this.visitorAnalytics.getUniqueVisitors,
            'Repeating Visitors': this.visitorAnalytics.getRepeatingVisitors,
            // getCheckInToCheckOutRatio: {}
          });
        } else {
          const data = {
            'Total Visitors': this.aggregate(this.visitorAnalytics.getTotalVisitors, range),
            'Unique Visitors': this.aggregate(this.visitorAnalytics.getUniqueVisitors, range),
            'Repeating Visitors': this.aggregate(this.visitorAnalytics.getRepeatingVisitors, range),
          }
          // this.incidentsCategoriesCountChart = this.generateIncidentStatusChart(data, 'Incident By Categories');
          this.getRepeatingVisitors = this.generateVisitorLineChart(data);
        }
        break;

      case "CheckInToCheckOutRatio":
        if (range === '1d') {
          this.getCheckInToCheckOutRatio = this.generateVisitorLineChart({ 'CheckIn To CheckOut Ratio': this.visitorAnalytics.getCheckInToCheckOutRatio });
        } else {
          const data = {
            'CheckIn To CheckOut Ratio': this.aggregate(this.visitorAnalytics.getCheckInToCheckOutRatio, range),
          }
          // this.getCheckInToCheckOutRatio = this.generateVisitorLineChart({ 'CheckIn To CheckOut Ratio': this.visitorAnalytics.getCheckInToCheckOutRatio });
          this.getCheckInToCheckOutRatio = this.generateVisitorLineChart(data);
        }
        break;

      case "visitorStatisticsData":
        if (range === '1d') {
          this.visitorStatisticsData = this.generateIncidentStatusChart(this.visitorAnalytics.visitorTypeTotals);
          // this.getCheckInToCheckOutRatio = this.generateVisitorLineChart({ 'CheckIn To CheckOut Ratio': this.visitorAnalytics.getCheckInToCheckOutRatio });
        } else {
          const data = this.aggregate(this.visitorAnalytics.visitorTypeTotals, range)
          // this.getCheckInToCheckOutRatio = this.generateVisitorLineChart({ 'CheckIn To CheckOut Ratio': this.visitorAnalytics.getCheckInToCheckOutRatio });
          this.visitorStatisticsData = this.generateIncidentStatusChart(data);
        }
        break;

      case "BookingByAssets":
        if (range === '1d') {
          // this.getBookingByDates = this.generateIncidentStatusChart({ "Booking": this.assetAnalytics.getBookingByDates });
          this.getBookingByAssets = this.generateIncidentStatusChart(this.bookingAnalytics.getBookingByAssets);
        } else {
          // this.getBookingByAssets = this.generateVisitorLineChart({ "Bookingd": this.assetAnalytics.getBookingByDates });
          const data = this.aggregate(this.bookingAnalytics.getBookingByAssets, range)
          // this.getCheckInToCheckOutRatio = this.generateVisitorLineChart({ 'CheckIn To CheckOut Ratio': this.visitorAnalytics.getCheckInToCheckOutRatio });
          this.getBookingByAssets = this.generateIncidentStatusChart({ data });
        }
        break;

      case "BookingByDates":
        if (range === '1d') {
          // this.getBookingByDates = this.generateIncidentStatusChart({ "Booking": this.assetAnalytics.getBookingByDates });
          this.getBookingByDates = this.generateVisitorLineChart({ "Booking": this.bookingAnalytics.getBookingByDates });
        } else {
          // this.getBookingByDates = this.generateVisitorLineChart({ "Bookingd": this.assetAnalytics.getBookingByDates });
          const data = this.aggregate(this.bookingAnalytics.getBookingByDates, range)
          // this.getCheckInToCheckOutRatio = this.generateVisitorLineChart({ 'CheckIn To CheckOut Ratio': this.visitorAnalytics.getCheckInToCheckOutRatio });
          this.getBookingByDates = this.generateVisitorLineChart({ data });
        }
        break;

      case "AverageTimeChart":
        if (range === '1d') {
          this.AverageTimeChart = this.generateStatusTrendChart(this.incidentAnalytics.averageTimePerStatus,);
        } else {
          // this.getBookingByDates = this.generateVisitorLineChart({ "Bookingd": this.assetAnalytics.getBookingByDates });
          const data = this.aggregate(this.incidentAnalytics.averageTimePerStatus, range)
          // this.getCheckInToCheckOutRatio = this.generateVisitorLineChart({ 'CheckIn To CheckOut Ratio': this.visitorAnalytics.getCheckInToCheckOutRatio });
          this.AverageTimeChart = this.generateStatusTrendChart(data);
        }
        break;

      case "ResolutionRateChart":
        if (range === '1d') {
          this.ResolutionRateChart = this.generateResolutionRateChart(this.incidentAnalytics.resolutionRatePerDay,);
        } else {
          // this.getBookingByDates = this.generateVisitorLineChart({ "Bookingd": this.assetAnalytics.getBookingByDates });
          const data = this.aggregate(this.incidentAnalytics.resolutionRatePerDay, range)
          // this.getCheckInToCheckOutRatio = this.generateVisitorLineChart({ 'CheckIn To CheckOut Ratio': this.visitorAnalytics.getCheckInToCheckOutRatio });
          this.ResolutionRateChart = this.generateResolutionRateChart(data);
        }
        break;

      default:
        break;
    }
    // this.IncidentTrendsbyCategory = this.generateChartOption(
    //   this.categorizedIncidents,
    //   range
    // );
  }


  // getISOWeekString(date: Date): string {
  //   const tmp = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  //   tmp.setUTCDate(tmp.getUTCDate() + 4 - (tmp.getUTCDay() || 7));
  //   const yearStart = new Date(Date.UTC(tmp.getUTCFullYear(), 0, 1));
  //   const weekNo = Math.ceil(
  //     ((tmp.getTime() - yearStart.getTime()) / 86400000 + 1) / 7
  //   );
  //   return `${tmp.getUTCFullYear()}-W${String(weekNo).padStart(2, '0')}`;
  // }

  getISOWeekString(d: Date): string {
    const tempDate = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    const dayNum = tempDate.getUTCDay() || 7;
    tempDate.setUTCDate(tempDate.getUTCDate() + 4 - dayNum);
    const yearStart = new Date(Date.UTC(tempDate.getUTCFullYear(), 0, 1));
    const weekNo = Math.ceil((((tempDate.getTime() - yearStart.getTime()) / 86400000) + 1) / 7);
    return `${tempDate.getUTCFullYear()}-W${String(weekNo).padStart(2, '0')}`;
  }


  /**
 * Aggregate daily data into either weekly or monthly sums.
 *
 * @param daily  Your DD-MM-YYYY → { status: count } object
 * @param period 'week' to group by ISO week, 'month' to group by calendar month
 */
  // aggregate(
  //   daily: any,
  //   period: '1d' | '1w' | '1m' | '1y'
  // ): any {
  //   const result: any = {};

  //   for (const [dateStr, counts] of Object.entries(daily)) {
  //     const [day, month, year] = dateStr.split('-').map(Number);
  //     const d = new Date(year, month - 1, day);

  //     // choose key formatter
  //     const key = period === '1w'
  //       ? this.getISOWeekString(d)
  //       : `${year}-${String(month).padStart(2, '0')}`;

  //     if (!result[key]) result[key] = {};
  //     for (const [status, num] of Object.entries(counts)) {
  //       result[key][status] = (result[key][status] || 0) + num;
  //     }
  //   }

  //   return result;
  // }

  aggregate(
    daily: any,
    period: '1d' | '1w' | '1m' | '1y'
  ): any {
    const result: any = {};

    for (const [dateStr, value] of Object.entries(daily)) {
      // Normalize date format:
      // Handle DD-MM-YYYY or YYYY-MM-DD
      let d: Date;

      if (dateStr.includes('-')) {
        const parts = dateStr.split('-').map(Number);

        if (parts[0] > 31) {
          // probably YYYY-MM-DD
          d = new Date(parts[0], parts[1] - 1, parts[2]);
        } else {
          // probably DD-MM-YYYY
          d = new Date(parts[2], parts[1] - 1, parts[0]);
        }
      } else {
        // fallback if no hyphens (unlikely in your data)
        d = new Date(dateStr);
      }

      let key = '';

      switch (period) {
        case '1d':
          key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
          break;
        case '1w':
          key = this.getISOWeekString(d);
          break;
        case '1m':
          key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
          break;
        case '1y':
          key = `${d.getFullYear()}`;
          break;
      }

      if (typeof value === 'number') {
        // Shape 2
        // result[key].count = (result[key].count || 0) + value;
        result[key] = (result[key] || 0) + value;
      } else if (typeof value === 'object') {
        // Shape 1
        if (!result[key]) result[key] = {};
        for (const [status, num] of Object.entries(value)) {
          result[key][status] = (result[key][status] || 0) + (num as number);
        }
      }
    }

    return result;
  }


  // private convertToSankeyData(rawData: any): { nodes: any[], links: any[] } {
  //   const links: any[] = [];
  //   const nodeSet = new Set<string>();

  //   for (const key in rawData) {
  //     const matches = key.match(/\((.*), (.*)\)/);
  //     if (matches) {
  //       const from = matches[1];
  //       const to = matches[2];
  //       const value = rawData[key]["item1"];

  //       links.push({
  //         source: from,
  //         target: to,
  //         value: value
  //       });

  //       nodeSet.add(from);
  //       nodeSet.add(to);
  //     }
  //   }

  //   const nodes = Array.from(nodeSet).map(name => ({ name }));
  //   return { nodes, links };
  // }

  transformData(data: any) {
    const nodeSet = new Set<string>();
    const links: { source: string, target: string, value: number }[] = [];

    for (const key of Object.keys(data)) {
      const match = key.match(/^\(([^,]+),\s*([^)]+)\)$/);
      if (match) {
        const source = match[1].trim();
        const target = match[2].trim();
        const value = data[key].item1;

        nodeSet.add(source);
        nodeSet.add(target);

        links.push({
          source,
          target,
          value
        });
      }
    }

    const nodes = Array.from(nodeSet).map(name => ({ name }));

    return { nodes, links };
  }

  generateTransitionMatrixChart(rawData: any): EChartsOption {
    const { nodes, links } = this.transformData(rawData);

    return {
      title: {
        text: 'Incident Status Flow',
        left: 'center'
      },
      tooltip: {
        trigger: 'item',
        triggerOn: 'mousemove'
      },
      series: [
        {
          type: 'sankey',
          // layout: 'none',
          emphasis: {
            focus: 'adjacency'
          },
          data: nodes,
          links: links,
          lineStyle: {
            color: 'gradient',
            curveness: 0.5
          },
          label: {
            color: '#333'
          }
        }
      ]
    };
  }

  buildBumpChart(transitions: any[]): any {
    const dateMap = new Map<string, { transition: string, count: number }[]>();

    for (const item of transitions) {
      const date = item.date.substring(0, 10);
      const transition = `${item.fromStatus} → ${item.toStatus}`;

      if (!dateMap.has(date)) {
        dateMap.set(date, []);
      }

      dateMap.get(date)!.push({
        transition,
        count: item.count
      });
    }

    const dates = Array.from(dateMap.keys()).sort();

    const transitionRanks: Record<string, number[]> = {};

    for (let date of dates) {
      const transitionsOnDate = dateMap.get(date)!;
      transitionsOnDate.sort((a, b) => b.count - a.count);

      transitionsOnDate.forEach((t, idx) => {
        if (!transitionRanks[t.transition]) {
          transitionRanks[t.transition] = new Array(dates.length).fill(null);
        }
        const dateIndex = dates.indexOf(date);
        transitionRanks[t.transition][dateIndex] = idx + 1;
      });
    }

    const series = Object.keys(transitionRanks).map((transition) => {
      return {
        name: transition,
        type: 'line',
        data: transitionRanks[transition],
        connectNulls: true,
        symbol: 'circle',
        label: {
          show: true,
          formatter: (params: any) => params.value ?? ''
        }
      };
    });

    return {
      title: {
        text: 'Transition Ranking Over Time'
      },
      tooltip: {
        trigger: 'axis'
      },
      legend: {
        top: 10,
        data: Object.keys(transitionRanks)
      },
      xAxis: {
        type: 'category',
        data: dates
      },
      yAxis: {
        type: 'value',
        inverse: true,
        min: 1,
        max: Math.max(
          ...Object.values(transitionRanks).map(ranks =>
            Math.max(...(ranks.filter(x => x != null) as number[]))
          )
        )
      },
      series: series
    };
  }

  generateTransitionStatusChart(
    rawData: {
      date: string;
      fromStatus: string;
      toStatus: string;
      count: number;
      percentage: number;
    }[],
    usePercentage = false,
    titleText = ''
  ): echarts.EChartsOption {
    // Step 1: Transform to object { date: { transition: value } }
    const grouped: { [date: string]: { [transition: string]: number } } = {};

    for (const item of rawData) {
      const date = item.date.slice(0, 10);
      const transition = `${item.fromStatus} → ${item.toStatus}`;
      if (!grouped[date]) grouped[date] = {};
      grouped[date][transition] =
        (grouped[date][transition] || 0) +
        (usePercentage ? item.percentage : item.count);
    }

    const dates = Object.keys(grouped).sort();

    // Step 2: Collect all unique transitions
    const allTransitionsSet = new Set<string>();
    for (const date of dates) {
      Object.keys(grouped[date]).forEach((transition) =>
        allTransitionsSet.add(transition)
      );
    }
    const allTransitions = Array.from(allTransitionsSet).sort();

    // Step 3: Compute total per date
    const totalPerDate = dates.map((date) => {
      const transitions = grouped[date];
      return Object.values(transitions).reduce((sum, val) => sum + val, 0);
    });

    // Step 4: Prepare stacked bar series
    const stackedBarSeries = allTransitions.map((transition) => ({
      name: transition,
      type: 'bar',
      stack: 'status',
      barWidth: 10,
      emphasis: {
        focus: 'series',
      },
      data: dates.map((date) => grouped[date][transition] || 0),
    }));

    // Step 5: Prepare total bar
    const totalBarSeries = {
      name: 'Total',
      type: 'bar',
      barGap: '10%',
      itemStyle: {
        color: '#00BFA5',
      },
      data: totalPerDate,
      label: {
        show: true,
        position: 'top',
        formatter: '{c}',
      },
    };

    // Step 6: Prepare trend line
    const totalTrendLineSeries = {
      name: 'Trend',
      type: 'line',
      data: totalPerDate,
      symbol: 'circle',
      symbolSize: 6,
      lineStyle: {
        color: 'red',
        width: 2,
      },
      label: {
        show: false,
      },
      emphasis: {
        focus: 'series',
      },
      z: 10,
    };

    return {
      title: {
        text: titleText,
        left: 'center',
        top: 0,
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
        formatter: (params: any) => {
          const total = params.reduce(
            (sum: number, item: any) => sum + (item.value || 0),
            0
          );
          return params
            .map(
              (item: any) =>
                `${item.seriesName}: ${item.value} (${(
                  (item.value / total) *
                  100
                ).toFixed(1)}%)`
            )
            .join('<br>');
        },
      },
      legend: {
        top: 10,
        type: 'scroll',
      },
      toolbox: {
        feature: {
          saveAsImage: {},
        },
      },
      xAxis: {
        type: 'category',
        data: dates,
        axisLabel: {
          rotate: 45,
        },
      },
      yAxis: {
        type: 'value',
      },
      series: [
        ...stackedBarSeries,
        totalBarSeries,
        totalTrendLineSeries,
      ] as echarts.EChartsOption['series'],
    };
  }

  generateVisitorLineChart(
    data: {
      [metricName: string]: { [date: string]: number }
    },
    titleText: string = ''
  ): EChartsOption {
    const metrics = Object.keys(data);

    // Step 1: Gather all unique dates
    const allDates = Array.from(
      new Set(
        metrics.flatMap(metric => Object.keys(data[metric]))
      )
    ).sort();

    // Step 2: Prepare ECharts series
    const series: LineSeriesOption[] = metrics.map(metric => ({
      name: metric,
      type: 'line',
      smooth: false,
      symbol: 'circle',
      symbolSize: 8,
      lineStyle: {
        width: 2
      },
      emphasis: {
        focus: 'series'
      },
      label: {
        show: true,
        formatter: (params) => {
          return `${params.value}`;
        }
      },
      data: allDates.map(date => data[metric][date] ?? 0)
    }));

    const option: EChartsOption = {
      title: {
        text: titleText,
        left: 'center',
        top: 10,
      },
      tooltip: {
        trigger: 'axis',
        formatter: (params: any) => {
          const tooltipLines = params.map((p: any) => {
            return `<b>${p.seriesName}</b>: ${p.data}`;
          });
          return tooltipLines.join('<br/>');
        }
      },
      legend: {
        top: 10,
        data: metrics
      },
      grid: {
        left: '5%',
        right: '5%',
        bottom: 80,
        containLabel: true
      },
      toolbox: {
        feature: {
          saveAsImage: {}
        }
      },
      xAxis: {
        type: 'category',
        data: allDates,
        axisLabel: {
          rotate: 45
        }
      },
      yAxis: {
        type: 'value',
        name: 'Count'
      },
      series
    };

    return option;
  }

  flipVisitorSchema(data: VisitorInput): VisitorOutput {
    const result: VisitorOutput = {
      expected: {},
      attended: {},
      ratio: {},
    };

    for (const date in data) {
      const { expected, attended, ratio } = data[date];
      result.expected[date] = expected;
      result.attended[date] = attended;
      result.ratio[date] = ratio;
    }

    return result;
  }


}
